import script from "./StudentPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentPicker.vue?vue&type=script&setup=true&lang=js"

import "./StudentPicker.vue?vue&type=style&index=0&id=6ecf849c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ecf849c"]])

export default __exports__